import React from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'react-bootstrap'
import notify from 'utils/notification'
import { notifyError } from 'pages/widgets/util'
import { BasicInfo, Style, Alerts, Layout, TwitterMetadata } from './components'
import {
  pathOr,
  omit,
  replace,
  splitAt,
  indexOf,
  pipe,
  trim,
  last
} from 'ramda'
import * as request from 'services/request'

// const FormSections = [BasicInfo, Style, Alerts, Layout, TwitterMetadata]
const FormSections = [BasicInfo, Style, Alerts, Layout, TwitterMetadata]
const FormSectionTitles = [
  'Basic Info',
  'Style',
  'Alerts',
  'Layout',
  'Twitter Metadata'
]
class MosaicDeployment extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      currentFormSection: 0,
      campaignId: this.props.campaignId,
      projectId: '',
      title: '',
      logoLink: '',
      logoSrc: '',
      optOutText: '',
      removeBRBranding: false,
      topBarColor: '#2250fc',
      topRightBarTitle: '#ffffff',
      searchButtonColor: '#2250fc',
      bottomBarColor: '#2250fc',
      bottomBarTextColor: '#ffffff',
      zoomInButtonColor: '#2250fc',
      zoomOutButtonColor: '#2250fc',
      zoomAnimationDuration: 250,
      alertImageNotFoundTitle: '',
      alertImageNotFoundbody: '',
      findMeButtonText: '',
      initialHorizontalPosition: 0,
      initialVerticalPosition: 200,
      initialZoomLevel: 2,
      zoomFraction: 1,
      layers: 8,
      twitterSite: '',
      twitterTitle: '',
      twitterDescription: '',
      onlyDeploy: false,
      twitterSiteImageUrl: 'https://bluerobot.com/images/bluerobot_logo.png',
      isSubmitting: false
    }

    this.handleNavigateForward = this.handleNavigateForward.bind(this)
    this.handleNavigateBackward = this.handleNavigateBackward.bind(this)
    this.handleFormFieldChange = this.handleFormFieldChange.bind(this)
    this.handleFormSubmit = this.handleFormSubmit.bind(this)
  }

  handleNavigateForward () {
    this.setState({ currentFormSection: this.state.currentFormSection + 1 })
  }

  handleNavigateBackward () {
    this.setState({ currentFormSection: this.state.currentFormSection - 1 })
  }

  handleFormFieldChange (formField) {
    return e => {
      this.setState({
        [formField]: pathOr(e, ['target', 'value'])(e)
      })
    }
  }

  async handleFormSubmit (e) {
    e.preventDefault()
    this.setState({ isSubmitting: true })
    const body = {
      ...this.state,
      topBarColor: replace('#', '', this.state.topBarColor),
      topRightBarTitle: replace('#', '', this.state.topRightBarTitle),
      searchButtonColor: replace('#', '', this.state.searchButtonColor),
      bottomBarColor: replace('#', '', this.state.bottomBarColor),
      bottomBarTextColor: replace('#', '', this.state.bottomBarTextColor),
      zoomInButtonColor: replace('#', '', this.state.zoomInButtonColor),
      zoomOutButtonColor: replace('#', '', this.state.zoomOutButtonColor),
      isSubmitting: false
    }

    try {
      const response = await request.authorized(
        `/widgets/${this.props.widgetId}/deploy_mosaic`,
        {
          method: 'POST',
          body: omit(['currentFormSection'], body)
        }
      )
      const successMessage = await response.text()
      const seperatorIndex = indexOf(':')(successMessage) + 1
      const deploymentUrl = pipe(
        splitAt(seperatorIndex),
        last,
        trim
      )(successMessage)

      window.open(deploymentUrl, '_blank')
      this.props.handleHideMosaicDeployModal()
      notify.success({ message: successMessage })
      this.setState({ isSubmitting: false })
    } catch (e) {
      notifyError(e, this.props.campaignId)
    }
  }

  render () {
    return (
      <Modal
        show={this.props.showMosaicDeployModal}
        onHide={this.props.handleHideMosaicDeployModal}
        className='modal-container'
        bsSize='large'
      >
        <Modal.Header closeButton closeLabel='Close Mosaic Deployment Modal'>
          <Modal.Title>
            <span className='caption-subject bold font-green-haze uppercase'>
              Configure Mosaic Deployment -{' '}
              {FormSectionTitles[this.state.currentFormSection]}
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {!this.state.isSubmitting && (
            <form onSubmit={this.handleFormSubmit} id='deployment-form'>
              <div className='modal-body'>
                <div className='modal-body-content'>
                  <div className='br-experience-info fluid-container'>
                    <div>
                      {FormSections.filter(
                        (Section, index) =>
                          index === this.state.currentFormSection
                      ).map((Section, index) => (
                        <Section
                          key={`FORM_SECTION_${index}`}
                          onChange={this.handleFormFieldChange}
                          state={this.state}
                        />
                      ))}
                    </div>
                  </div>
                </div>
                <div style={{ float: 'right' }}>
                  <button
                    type='button'
                    onClick={this.handleNavigateBackward}
                    disabled={!this.state.currentFormSection}
                    className='btn green-haze'
                    id='back-button'
                  >
                    Back
                  </button>

                  {this.state.currentFormSection !==
                    FormSections.length - 1 && (
                    <button
                      type='button'
                      onClick={this.handleNavigateForward}
                      className='btn green-haze'
                      id='next-button'
                    >
                      Next
                    </button>
                  )}
                  {this.state.currentFormSection ===
                    FormSections.length - 1 && (
                    <button
                      type='submit'
                      className='btn green-haze'
                      id='submit-button'
                    >
                      Deploy Mosaic
                    </button>
                  )}
                </div>
              </div>
            </form>
          )}
        </Modal.Body>
      </Modal>
    )
  }
}

MosaicDeployment.propTypes = {
  showMosaicDeployModal: PropTypes.bool.isRequired,
  handleHideMosaicDeployModal: PropTypes.func.isRequired,
  widgetId: PropTypes.string.isRequired,
  campaignId: PropTypes.string.isRequired
}

export default MosaicDeployment



// WEBPACK FOOTER //
// ./src/pages/widgets/form/configure-mosaic-deployment/index.js